import React, { Fragment, useContext } from "react";
import { Form, Button, Icon } from "@tencent/universe-ui/build/lib";
import { CheckIcon } from 'tdesign-icons-react';
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import isBase64 from 'is-base64';
import { Base64 } from 'js-base64';
import rehypeRaw from 'rehype-raw';
import rehypeKatex from 'rehype-katex'
import remarkMath from 'remark-math'
import { OcrTable, DownloadExcel, GetProperty } from '../../utils/index.js';
import { transV2, getType, isObjectEmptyValues } from '../../utils/index.js';
import EduCom from './edu.jsx';
import EduMarkCom from './EduMark.jsx';
import EssayEduCom from './EssayEdu.jsx';
import { Collapse, Card, Divider } from 'tdesign-react';
import JsonView from 'react18-json-view';
import invoiceConfig from '../../const/invoice.json';
import { MathJax } from "better-react-mathjax";
const { Panel } = Collapse;

const base64ToStr = (base64Str) => {
  if (isBase64(base64Str)) {
    return Base64.decode(base64Str);
  }
  return base64Str;
};


const deepseekingCom = (msg = '大模型智能抽取中...') => {
  return <>
    <div className="ocrDemo-seeking-container">
      <div className="ocrDemo-icon-seeking"></div>
      <div className="ocrDemo-seeking__text">{msg}</div>
    </div>
  </>
}

const resultingCom = (msg = '识别中...') => {
  return <>
    <div className="ocrDemo-resulting-container">
      <div className="ocrDemo-icon-resulting"></div>
      <div className="ocrDemo-resulting__text">{msg}</div>
    </div>
  </>
}

const emptyCom = (msg = '暂无结果') => {
  return <>
    <div className="ocrDemo-empty-container">
      <div className="ocrDemo-icon-empty"></div>
      <div className="ocrDemo-empty__text">{msg}</div>
    </div>
  </>
}

function OutputParams({ request, resultType, waitingType = 'resulting', detail, isLoading, isMarkLoading, rectConfig, resultConfig, params, showDownload, selectRect, onSelect, eduMarkData, rects }) {
  const childMapCom = ({ key, value, dep, config = resultConfig.fieldsMap }) => {
    let com = <></>;

    const type = getType(value);
    switch (type) {
      case 'null':
        break;
      case 'string':
      case 'number':
        if (value || value == 0) {
          if (dep === 0) {
            com = <Form.Item
              label={config[key]?._Label || config[key] || key}
            >
              {value}
            </Form.Item>
          } else {
            com = <p className="mb-10">
              <span><b>{config[key]?._Label || config[key] || key}: </b></span>
              <span>{value}</span>
            </p>
          }
        }
        break;
      case 'bollean':
        if (dep === 0) {
          com = <Form.Item
            label={config[key]?._Label || config[key] || key}
          >
            {value}
          </Form.Item>
        } else {
          com = <p className="mb-10">
            <span><b>{config[key]?._Label || config[key] || key}: </b></span>
            <span>{value}</span>
          </p>
        }
        break;
      case 'object':
        // 对象下如果都是空的，则不显示
        if (!isObjectEmptyValues(value)) {
          com = <>
            {
              dep === 0 ? <>
                <Form.Item
                  label={config[key]?._Label || config[key] || key}
                >
                  {
                    Object.keys(value)?.map((ckey, index) => {
                      if (!ckey || !value[ckey]) return <></>
                      const donShowChild = ['string', 'number', 'boolean'].includes(getType(value[ckey]));
                      return donShowChild ? <p className="mb-10">
                        <span><b>{config[key][ckey]?._Label || config[key][ckey] || ckey}: </b></span>
                        <span>{value[ckey]}</span>
                      </p> :
                        <>{
                          childMapCom({
                            key: ckey,
                            value: value[ckey],
                            dep: 1,
                            config: config[key]
                          })
                        }</>
                    })
                  }
                </Form.Item>
              </> : <>
                <p className="mb-10">
                  <span>
                    {
                      Object.keys(value)?.map((ckey, index) => {
                        if (!ckey || !value[ckey]) return <></>
                        const donShowChild = ['string', 'number', 'boolean'].includes(getType(value[ckey]));
                        return donShowChild ? <p className="mb-10">
                          <span><b>{config[ckey]?._Label || config[ckey] || ckey}: </b></span>
                          <span>{value[ckey]}</span>
                        </p> : <>{
                          childMapCom({
                            key: ckey,
                            value: value[ckey],
                            dep: 1,
                            config: config[key]
                          })
                        }</>
                      })
                    }
                  </span>
                </p>
              </>
            }
          </>
        }
        break;
      case 'array':
        if (value.length > 0) {
          com = <>{
            value.map((item, index) => {
              const donShowChild = ['string', 'number', 'boolean'].includes(item);
              let label = config[key]?._Label || config[key] || key
              return <>
                <Form.Item
                  key={index}
                  label={`${label}:识别结果${index + 1}`}
                >
                  {donShowChild ? item : childMapCom({ key: key, value: item, dep: 1, config: config[key] })}
                </Form.Item>
              </>
            })
          }
          </>
        }

        break;
    }
    return com
  }
  const handleDownload = () => {
    DownloadExcel(params.Data);
  }
  const handleGetWarn = () => {
    let warnList = [];
    Object.keys(params).map(key => {
      if (params[key] && params[key].IsWarn) {
        warnList.push({
          key,
          ...params[key]
        })
      }
    })
    return warnList
  }
  const getSelectRectKey = ({ data, key, valStr }) => {
    try {
      if (!data || !valStr) return '';
      if (!key) return valStr;
      let coordStr = GetProperty(data, key)
      return valStr + JSON.stringify(coordStr)
    } catch (err) {
      return ''
    }
  }
  const dealParams = (params, config = config, type = config.type) => {
    try {
      let _params = params;
      if (JSON.stringify(_params) === '{}') return <>{emptyCom()}</>;
      let paramsCon = <>{emptyCom()}</>;
      switch (type) {
        case 'markdown':
          paramsCon = params[config.markdownContent] && <>
            {
              request[config.markdownKey] === config.markdownVal ?
                <div className="markdown_container">
                  <ReactMarkdown remarkPlugins={[remarkGfm, remarkMath]} rehypePlugins={[rehypeRaw, rehypeKatex]}>
                    {base64ToStr(params[config.markdownContent])}
                  </ReactMarkdown>
                </div> :

                <div className="markdown-download">
                  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.5 6.06665C3.5 4.75986 3.5 4.10646 3.75432 3.60734C3.97802 3.16829 4.33498 2.81134 4.77402 2.58763C5.27315 2.33331 5.92654 2.33331 7.23333 2.33331H18.2869C18.8576 2.33331 19.143 2.33331 19.4115 2.39778C19.6496 2.45494 19.8772 2.54922 20.086 2.67715C20.3215 2.82145 20.5232 3.02323 20.9268 3.42678L23.4065 5.90651C23.8101 6.31007 24.0119 6.51184 24.1562 6.74731C24.2841 6.95608 24.3784 7.18369 24.4355 7.42177C24.5 7.69031 24.5 7.97567 24.5 8.54638V21.9333C24.5 23.2401 24.5 23.8935 24.2457 24.3926C24.022 24.8317 23.665 25.1886 23.226 25.4123C22.7269 25.6666 22.0735 25.6666 20.7667 25.6666H7.23333C5.92654 25.6666 5.27315 25.6666 4.77402 25.4123C4.33498 25.1886 3.97802 24.8317 3.75432 24.3926C3.5 23.8935 3.5 23.2401 3.5 21.9333V6.06665Z" fill="#E6F8EF" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M23.9167 21.9333V8.54638C23.9167 7.9479 23.9129 7.74374 23.8683 7.55795C23.8254 7.37938 23.7547 7.20868 23.6588 7.0521C23.559 6.88919 23.4172 6.74218 22.9941 6.31899L20.5143 3.83926C20.0911 3.41607 19.9441 3.27436 19.7812 3.17453C19.6246 3.07858 19.4539 3.00787 19.2754 2.965C19.0896 2.9204 18.8854 2.91665 18.2869 2.91665H7.23333C6.57031 2.91665 6.10813 2.9171 5.74831 2.9465C5.39529 2.97534 5.19247 3.02911 5.03885 3.10738C4.70957 3.27516 4.44185 3.54288 4.27407 3.87216C4.1958 4.02579 4.14203 4.22861 4.11319 4.58162C4.08379 4.94144 4.08333 5.40363 4.08333 6.06665V21.9333C4.08333 22.5963 4.08379 23.0585 4.11319 23.4183C4.14203 23.7714 4.1958 23.9742 4.27407 24.1278C4.44185 24.4571 4.70957 24.7248 5.03885 24.8926C5.19247 24.9708 5.39529 25.0246 5.74831 25.0535C6.10813 25.0829 6.57031 25.0833 7.23333 25.0833H20.7667C21.4297 25.0833 21.8919 25.0829 22.2517 25.0535C22.6047 25.0246 22.8075 24.9708 22.9611 24.8926C23.2904 24.7248 23.5581 24.4571 23.7259 24.1278C23.8042 23.9742 23.858 23.7714 23.8868 23.4183C23.9162 23.0585 23.9167 22.5963 23.9167 21.9333ZM3.75432 3.60734C3.5 4.10646 3.5 4.75986 3.5 6.06665V21.9333C3.5 23.2401 3.5 23.8935 3.75432 24.3926C3.97802 24.8317 4.33498 25.1886 4.77402 25.4123C5.27315 25.6666 5.92654 25.6666 7.23333 25.6666H20.7667C22.0735 25.6666 22.7269 25.6666 23.226 25.4123C23.665 25.1886 24.022 24.8317 24.2457 24.3926C24.5 23.8935 24.5 23.2401 24.5 21.9333V8.54638C24.5 7.97567 24.5 7.69031 24.4355 7.42177C24.3784 7.18369 24.2841 6.95608 24.1562 6.74731C24.0119 6.51184 23.8101 6.31007 23.4065 5.90651L20.9268 3.42678C20.5232 3.02323 20.3215 2.82145 20.086 2.67715C19.8772 2.54922 19.6496 2.45494 19.4115 2.39778C19.143 2.33331 18.8576 2.33331 18.2869 2.33331H7.23333C5.92654 2.33331 5.27315 2.33331 4.77402 2.58763C4.33498 2.81134 3.97802 3.16829 3.75432 3.60734Z" fill="#C0EBD7" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7176 14.8621L8.90274 9.41927C8.76339 9.22045 8.90561 8.94708 9.1484 8.94708H10.8761C11.0392 8.94708 11.192 9.02658 11.2856 9.1601L13.9999 13.0327L16.7142 9.1601C16.8078 9.02658 16.9606 8.94708 17.1236 8.94708H18.8514C19.0941 8.94708 19.2364 9.22045 19.097 9.41927L15.2821 14.8621L18.9793 20.137C19.1187 20.3358 18.9765 20.6092 18.7337 20.6092H17.006C16.8429 20.6092 16.6901 20.5297 16.5965 20.3962L13.9999 16.6915L11.4032 20.3962C11.3097 20.5297 11.1568 20.6092 10.9938 20.6092H9.26609C9.0233 20.6092 8.88107 20.3358 9.02042 20.137L12.7176 14.8621Z" fill="#0FB87F" />
                  </svg>
                  <span>Excel表格仅支持下载查看</span>
                </div>

            }</>
          break;
        case 'OpenResult':
          const jsonRes = resultConfig.jsonRes || 'StructuralList'
          paramsCon = <>
            {
              <Collapse
                className="OpenResult_thinking"
                borderless
                defaultValue="default"
                expandIcon
                expandIconPlacement="right"
                expandOnRowClick>
                <Panel value="default" header={isLoading ? '思考中' : '已思考'}>
                  <span style={{ whiteSpace: 'pre-line' }}>{
                    isLoading && !params.ThoughtContent ? "..." : params.ThoughtContent
                  }</span>

                </Panel>
              </Collapse>
            }

            {
              isLoading ? deepseekingCom() : params[jsonRes]?.length > 0 && <>
                <div className="OpenResult_tips">
                  <CheckIcon className="OpenResult_tips__icon" />
                  根据您配置的字段,我们为您抽取出如下结果
                </div>
                <Card
                  bordered
                  headerBordered
                  title="JSON"
                  actions={
                    <i onClick={() => clickHandler(params[jsonRes])} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.8667 3H11.6667H8.13332H6.0531C6.07427 2.89777 6.10389 2.80931 6.14531 2.72801C6.27315 2.47713 6.47712 2.27316 6.728 2.14532C7.01322 2 7.38659 2 8.13332 2H11.8667C12.6134 2 12.9868 2 13.272 2.14532C13.5229 2.27316 13.7268 2.47713 13.8547 2.72801C14 3.01323 14 3.3866 14 4.13333V9.2C14 9.94674 14 10.3201 13.8547 10.6053C13.7268 10.8562 13.5229 11.0602 13.272 11.188C13.1907 11.2294 13.1022 11.259 13 11.2802V4.33333L13 4.32807V4.13333C13 3.74346 12.9992 3.5112 12.9851 3.33903C12.9766 3.23396 12.9652 3.18979 12.9616 3.17795C12.9302 3.11843 12.8816 3.06979 12.822 3.03843C12.8102 3.03476 12.766 3.02343 12.661 3.01484C12.4888 3.00078 12.2565 3 11.8667 3ZM12.8255 3.03964L12.8235 3.03889L12.8249 3.03937C12.8253 3.03954 12.8255 3.03963 12.8255 3.03964ZM12.9605 3.17494C12.9604 3.17462 12.9604 3.17448 12.9604 3.1745L12.9611 3.17652C12.9609 3.17579 12.9607 3.17527 12.9605 3.17494ZM4.13333 5C3.74346 5 3.5112 5.00078 3.33903 5.01484C3.23396 5.02343 3.18979 5.03476 3.17795 5.03843C3.11843 5.06979 3.06979 5.11843 3.03843 5.17795C3.03476 5.18979 3.02343 5.23396 3.01484 5.33903C3.00078 5.5112 3 5.74346 3 6.13333V11.8667C3 12.2565 3.00078 12.4888 3.01484 12.661C3.02343 12.766 3.03476 12.8102 3.03843 12.8221C3.06979 12.8816 3.11843 12.9302 3.17795 12.9616C3.18978 12.9652 3.23395 12.9766 3.33903 12.9852C3.5112 12.9992 3.74346 13 4.13333 13H9.86667C10.2565 13 10.4888 12.9992 10.661 12.9852C10.766 12.9766 10.8102 12.9652 10.8221 12.9616C10.8816 12.9302 10.9302 12.8816 10.9616 12.8221C10.9652 12.8102 10.9766 12.766 10.9852 12.661C10.9992 12.4888 11 12.2565 11 11.8667V6.13333C11 5.74346 10.9992 5.5112 10.9852 5.33903C10.9766 5.23396 10.9652 5.18979 10.9616 5.17795C10.9302 5.11843 10.8816 5.06979 10.822 5.03843C10.8102 5.03476 10.766 5.02343 10.661 5.01484C10.4888 5.00078 10.2565 5 9.86667 5H4.13333ZM10.8255 5.03964L10.8235 5.03889C10.8249 5.03936 10.8255 5.03962 10.8255 5.03964ZM10.9604 5.1745C10.9604 5.17446 10.9606 5.1751 10.9611 5.17652L10.9604 5.1745ZM10.9604 12.8255L10.9611 12.8235C10.9606 12.8249 10.9604 12.8255 10.9604 12.8255ZM10.8255 12.9604C10.8255 12.9604 10.8249 12.9606 10.8235 12.9611L10.8255 12.9604ZM3.1745 12.9604L3.17652 12.9611C3.17509 12.9606 3.17446 12.9604 3.1745 12.9604ZM3.03964 12.8255C3.03962 12.8255 3.03936 12.8249 3.03889 12.8235L3.03964 12.8255ZM3.03964 5.1745L3.03889 5.17652C3.03936 5.1751 3.03962 5.17446 3.03964 5.1745ZM3.1745 5.03964C3.17446 5.03962 3.1751 5.03936 3.17652 5.03889L3.1745 5.03964ZM2 6.13333C2 5.3866 2 5.01323 2.14532 4.72801C2.27316 4.47713 2.47713 4.27316 2.72801 4.14532C3.01323 4 3.3866 4 4.13333 4H9.86667C10.6134 4 10.9868 4 11.272 4.14532C11.5229 4.27316 11.7268 4.47713 11.8547 4.72801C12 5.01323 12 5.3866 12 6.13333V11.8667C12 12.6134 12 12.9868 11.8547 13.272C11.7268 13.5229 11.5229 13.7268 11.272 13.8547C10.9868 14 10.6134 14 9.86667 14H4.13333C3.3866 14 3.01323 14 2.72801 13.8547C2.47713 13.7268 2.27316 13.5229 2.14532 13.272C2 12.9868 2 12.6134 2 11.8667V6.13333Z" fill="#030A26" fill-opacity="0.65" />
                      </svg>
                      <span style={{ marginLeft: '4px' }}>复制</span>
                    </i>
                  }
                  hoverShadow
                  style={{ width: '100%' }}
                >
                  <JsonView src={params[jsonRes]} keyName={false} theme="winter-is-coming" displayDataTypes={false} />
                </Card>
              </>
            }
          </>
          break;
        case 'Image':
          const imageField = config.imageResultField || 'Image';
          paramsCon = <>
            {
              params[imageField] ? <div class="ocr_tips__success">
                <Icon size={24} name="success" color="#00b175"></Icon>
                <span>处理成功</span>
              </div> : ''
            }</>
          break;
        case 'eduAgent':
          paramsCon = <>
            {
              params[config.firstField]?.map((mark, index) => {
                return <>
                  {
                    mark[config.value] &&
                    <Form.Item
                      key={index}
                      label={mark[config.key]}
                    >
                      {
                        !isLoading && mark[config.value] &&
                        <MathJax dynamic hideUntilTypeset={"first"}>
                          {mark[config.value]}
                        </MathJax>
                      }
                    </Form.Item>
                  }
                </>
              })
            }
          </>
          break;
        case 'list':
          paramsCon = <>
            {
              params[config.firstField]?.map((i, index) => {
                const selectRectVal = getSelectRectKey({
                  data: i,
                  key: detail?.rectConfig?.RectKey,
                  valStr: i[config.secondField]
                });
                return <Form.Item
                  className={`${selectRectVal && selectRect == selectRectVal ? 'isSelect' : ''} list`}
                  key={index}
                  label=""
                  onClick={() => {
                    onSelect && onSelect(i[config.secondField], selectRectVal);
                  }}
                >
                  {i[config.secondField]}
                </Form.Item>

              }
              )
            }
          </>
          break;
        case 'math':
          paramsCon = <>
            {
              params[config.firstField]?.map((i, index) => {
                const selectRectVal = getSelectRectKey({
                  data: i,
                  key: detail?.rectConfig?.RectKey,
                  valStr: i[config.secondField]
                });
                return (
                  <Form.Item
                    className={`math-container ${selectRect && selectRect == selectRectVal ? 'isSelect' : ''} list`}
                    key={index}
                    label=""
                    onClick={() => {
                      onSelect && onSelect(i[config.secondField], selectRectVal);
                    }}
                  >
                    {
                      i[config.secondField] && <MathJax dynamic hideUntilTypeset={"first"}>
                        {i[config.secondField]}
                      </MathJax>
                    }

                  </Form.Item>
                )
              }
              )
            }
          </>
          break;
        case 'childMap':
          _params = params;
          if (config.firstField) {
            _params = params[config.firstField];
          }
          let keys = Object.keys(_params).reverse()
          paramsCon = <>
            {
              _params && keys?.map((key, index) => {
                let _key = key;
                const _value = JSON.parse(JSON.stringify(_params[_key]))
                if (key === 'RequestId' || config.ignoreKey?.includes(key)) {
                  return <></>
                } else if (key === "Type" && config.typeList?.length > 0) {
                  const _typeValue = config.typeList[_value];
                  return childMapCom({ key: "Type", value: _value, dep: 0, config: config.fieldsMap })
                } else {
                  return childMapCom({ key: _key, value: _value, dep: 0, config: config.fieldsMap })
                }
              })
            }
          </>
          break;
        case 'warnMap':
          // TODO: 改为递归
          _params = params;
          if (config.firstField) {
            _params = params[config.firstField];
          }
          paramsCon = <>
            {
              _params && Object.keys(_params)?.reverse().filter(i => {
                return Object.keys(config.fieldsMap)?.includes(i)
              })?.map((key, index) => (
                <>
                  {_params[key] && <>
                    {
                      typeof _params[key] === 'object' ? <>
                        {
                          config.fieldsMap[key]._Label && <Form.Item
                            key={index}
                            label={config.fieldsMap[key]._Label}
                          >
                          </Form.Item>
                        }
                        {
                          Object.keys(_params[key])?.map((ckey, index) => {
                            let content = typeof (_params[key][ckey]) === 'object' ? _params[key][ckey][config.fieldsMapContent] : _params[key][ckey];
                            let warnList = []
                            if (ckey === 'WarnInfos') {
                              let WarnInfos = _params[key][ckey];
                              Object.keys(WarnInfos)?.map(warn => {
                                if (WarnInfos[warn] > 0) {
                                  warnList.push(config.warnsList[warn])
                                }
                              })
                            }
                            return (
                              <>
                                {_params[key][ckey] && config.fieldsMap[key][ckey] && content &&
                                  <Form.Item
                                    key={index}
                                    label={config.fieldsMap[key][ckey]}
                                  >
                                    {content}
                                  </Form.Item>
                                }
                                {
                                  warnList.length > 0 && warnList.map((warns, index) => {
                                    return (
                                      <Form.Item
                                        active
                                        label={`告警${index + 1}`}
                                        className={`unv-form__item-group`}
                                      >
                                        <p className="mb-10"><span>{warns}</span></p>
                                      </Form.Item>
                                    )
                                  })
                                }
                              </>
                            )
                          })
                        }
                      </> :
                        <Form.Item
                          key={index}
                          label={config.fieldsMap[key]}
                        >
                          {_params[key]}
                        </Form.Item>
                    }
                  </>
                  }
                </>
              ))
            }
          </>
          break;
        case 'map':
          _params = params;
          if (config.firstField) {
            if (typeof config.firstField === 'string') {
              _params = params[config.firstField];
            } else {
              const key = config.firstField.filter(i => _params[i]) ? config.firstField.filter(i => _params[i])[0] : ''
              _params = _params[key];
            }
          }
          paramsCon = <>
            {
              _params && Object.keys(_params)?.filter(i => {
                return Object.keys(config.fieldsMap)?.includes(i)
              })?.map((key, index) => (
                <>
                  {_params[key] && <Form.Item
                    key={index}
                    label={config.fieldsMap[key]}
                  >
                    {_params[key]}
                  </Form.Item>
                  }
                </>
              ))
            }
          </>
          break;
        case 'keyMap':
          // TODO： 和childmap合并改为递归
          paramsCon = <>
            {
              params[config.firstField]?.map((i, index) => {
                const selectRectVal = getSelectRectKey({
                  data: i,
                  key: detail?.rectConfig?.RectKey,
                  valStr: i[config.key2 || 'Value']
                });
                return <>
                  {
                    config.secondField ? <>
                      {
                        i[config.secondField]?.map((v, vIndex) =>
                        (
                          <>
                            {
                              !(config.hide && v[config.key1 || 'Name'].includes(config.hide)) &&
                              <Form.Item
                                className={`${selectRect == selectRectVal ? 'isSelect' : ''}`}
                                key={vIndex}
                                label={v[config.key1 || 'Name']}
                                onClick={() => {
                                  onSelect && onSelect(v[config.key2 || 'Value'], selectRectVal);
                                }}
                              >
                                {v[config.key2 || 'Value']}
                              </Form.Item>
                            }
                          </>
                        )
                        )

                      }
                    </> : <>
                      {
                        !(config.hide && i[config.key1 || 'Name'].includes(config.hide)) &&
                        <Form.Item
                          key={index}
                          className={`${selectRect && selectRect == selectRectVal ? 'isSelect' : ''}`}
                          label={i[config.key1 || 'Name']}
                          onClick={() => {
                            onSelect && onSelect(i[config.key2 || 'Value'], selectRectVal);
                          }}
                        >
                          {i[config.key2 || 'Value']}
                        </Form.Item>
                      }
                    </>
                  }

                </>

              })
            }
          </>
          break;
        case 'SealOCR':
          paramsCon = <>
            {
              params[config.firstField]?.map((v, index) => {
                const selectRectVal = getSelectRectKey({
                  data: v,
                  key: config?.RectKey || detail?.rectConfig?.RectKey,
                  valStr: v[config.secondField]
                });
                return <>
                  <Form.Item
                    active
                    label={`印章${index + 1}`}
                    className={`${selectRect && selectRect == selectRectVal ? 'isSelect' : ''} unv-form__item-group`}
                    onClick={() => {
                      onSelect && onSelect(v[config.secondField], selectRectVal);
                    }}
                  >
                    <p className="mb-10"><span>印章类型:</span><span>{config.SealShapeList[v.SealShape]}</span></p>
                    <p className="mb-10"><span>印章主要内容:</span><span>{v[config.secondField]}</span></p>
                    {
                      v.OtherTexts?.map((t, tIndex) => (
                        <p className="mb-10" key={tIndex}><span>其他文本内容</span><span>{t}</span></p>
                      ))
                    }
                  </Form.Item>
                </>
              }
              )
            }
          </>
          break;
        case 'warn':
          const _warnList = handleGetWarn();
          paramsCon = <>
            {
              _warnList.length > 0 ? <>
                {
                  _warnList?.map((item, index) => {
                    const selectRectVal = getSelectRectKey({
                      data: item,
                      key: '',
                      valStr: `${item.key}-${item[config.riskNum]}`
                    });
                    return (
                      <Form.Item
                        active
                        label={`告警${index + 1}`}
                        className={`${selectRect && selectRect == selectRectVal ? 'isSelect' : ''} unv-form__item-group`}
                        onClick={() => {
                          onSelect && onSelect(item.key, selectRectVal);
                        }}
                      >
                        <p className="mb-10"><span>告警类型:</span><span>{config.warnsList[item.key]}</span></p>
                        {
                          item[config.secondField] && <p className="mb-10"><span>特殊判定:</span><span>{item[config.secondField]}</span></p>
                        }
                      </Form.Item>
                    )
                  })
                }
              </> : <div style={{ paddingLeft: '22px', paddingTop: '10px' }}>未检测到待告警信息</div>

            }
          </>
          break;
        case 'risk':
          const _riskList = handleGetWarn();
          paramsCon = <>
            {
              _riskList.length > 0 ? <>
                <Form.Item
                  label=""
                >
                  鉴伪结果：
                </Form.Item>
                {
                  _riskList.map((item, index) => {
                    const selectRectVal = getSelectRectKey({
                      data: item,
                      key: '',
                      valStr: `${item.key}-${item[config.riskNum]}`
                    });
                    return (
                      <Form.Item
                        active
                        label={`${index + 1}、风险程度-${config.warnsList[item.key].warnTitle}`}
                        className={`${selectRect && selectRect == selectRectVal ? 'isSelect' : ''} unv-form__item-group`}
                        onClick={() => {
                          onSelect && onSelect(item.key, selectRectVal);
                        }}
                      >
                        <p className="mb-10">
                          <span>{item[config.riskNum]},{config.warnsList[item.key].tips}</span>
                        </p>
                      </Form.Item>
                    )
                  })
                }
              </> : <div style={{ paddingLeft: '22px', paddingTop: '10px' }}>未检测到待告警信息</div>

            }
          </>
          break;
        case 'QrcodeOCR':
          paramsCon = <>
            {
              params.CodeResults?.map((code, index) => {
                const selectRectVal = getSelectRectKey({
                  data: code,
                  key: detail?.rectConfig?.RectKey,
                  valStr: code.Url
                });
                return (
                  <div
                    className={`${selectRect && selectRect == selectRectVal ? 'isSelect' : ''}`}
                    key={index} onClick={() => {
                      onSelect && onSelect(code[config.key], selectRectVal);
                    }}>
                    <Form.Item
                      label="类型"
                    >
                      {code.TypeName}
                    </Form.Item>
                    <Form.Item
                      label="包含的地址"
                    >
                      {code.Url}
                    </Form.Item>
                  </div>
                )
              }
              )
            }
            {
              params.ImgSize && <Form.Item
                label="图片大小"
              >
                {`宽:${params.ImgSize.Wide}  高:${params.ImgSize.High}`}
              </Form.Item>
            }
          </>
          break;
        case "table": // type: 7表格识别
          // 接口暂不支持日文无线表格识别，若传入日文无线表格，返回0
          //  0 为非表格文本，1 为有线表格，2 为无线表格
          // 表格头部是非表格type==0，主体是表格type==1。以前都是1
          if (params.TableDetections?.map((o) => o.Type).every((type) => type === 0)) {
            let cells = params.TableDetections?.map((item) => item.Cells).reduce((acc, curr) => {
              return acc.concat(curr);
            }, []);
            let arr = [];
            for (let v of cells) {
              arr.push(v.Text);
            }
            return arr;
          }
          const list = params.TableDetections?.filter((item) => [0, 1, 2].includes(item.Type)).sort((a, b) => a.Type - b.Type);
          const formList = list?.filter((item) => [0].includes(item.Type));
          const tableList = list?.filter((item) => [1, 2].includes(item.Type));
          if (list?.length <= 0) return '';
          let tableTem = <>
            {/* formList */}
            {
              formList?.length > 0 && formList?.map((list_item, i) => {
                return (
                  <>
                    {
                      list_item.Cells?.map((cell, i) => (
                        <Form.Item
                          className="list"
                          key={i}
                          label=""
                        >
                          {cell.Text}
                        </Form.Item>
                      ))

                    }
                  </>
                )
              }
              )
            }
            {/* tableList */}
            {
              tableList?.length > 0 && tableList?.map((list_item, i) => {
                const tableData = OcrTable(list_item);
                return (
                  <>
                    {
                      [1, 2].includes(list_item.Type) &&
                      <p class="flex just-space-between  align-center mtb-10">
                        <Button type="hole">
                          <span>表格{i + 1}</span>
                        </Button>
                        {
                          showDownload && <Button type="link" onClick={handleDownload}>导出表格</Button>
                        }
                      </p>
                    }
                    <div className="unv-table__box__container">
                      <table border="1" className="unv-table__box">
                        {
                          tableData.length > 0 && tableData?.map((tr, tri) => {
                            return (
                              <>
                                <tr key={tri}>
                                  {
                                    tr.length > 0 && tr?.map((td, tdi) => (
                                      // <td key={tdi} colSpan={td.occupyCol} rowSpan={td.occupyRow}>{td.cell_content_text.replace('\n', '<br />')}</td>
                                      <td key={tdi} colSpan={td.occupyCol} rowSpan={td.occupyRow}>{td.cell_content_text}</td>
                                    ))
                                  }
                                </tr>
                              </>
                            )
                          })
                        }
                      </table>
                    </div>

                  </>
                );

              })
            }
          </>;
          paramsCon = tableTem;
          break;
        case "smartList": // 智能结构化
          // let smartListType = detail?.rectConfig?.useWordList && params?.WordList?.length > 0 ? 'WordList' : 'StructuralList'
          let _params = transV2(params?.StructuralList);
          let showWordList = detail?.rectConfig?.useWordList && params?.WordList?.length > 0;
          paramsCon = <>
            {
              !detail?.showWordListOnly &&
              <>
                {
                  _params?.list?.length > 0 &&
                  <>
                    {_params.list.map((item, index) => {
                      const selectRectVal = getSelectRectKey({
                        data: item,
                        key: 'originItemCoord',
                        valStr: `${item.Name}${item.Value}`
                      });
                      return (
                        <Form.Item
                          key={index}
                          label={item.Name}
                          onClick={() => {
                            onSelect && onSelect(item.Value, selectRectVal);
                          }}
                          className={`${selectRect && selectRect == selectRectVal ? 'isSelect' : ''} `}
                        >
                          {item.Value}
                        </Form.Item>
                      )
                    }
                    )}
                  </>
                }
                {_params.table.map((item, index) => (
                  <>
                    <p class="flex just-space-between  align-center mtb-10">
                      <Button type="hole">
                        <span>表格{index + 1}</span>
                      </Button>
                    </p>
                    <div className="unv-table__container">
                      <table style={{ minWidth: item.header.length * 100 }}>
                        <tbody>
                          {/* 表格header */}
                          <tr>
                            {
                              item.header.map(header => (
                                <td style={{ width: '100px' }} >{header}</td>
                              ))
                            }
                          </tr>
                          {
                            item.content.map((line, j) => (
                              <tr>
                                {
                                  line.map(tr => (
                                    <td style={{ width: '100px' }} >{tr}</td>
                                  ))
                                }
                              </tr>
                            ))
                          }

                        </tbody>
                      </table>
                    </div>
                  </>
                )
                )}
              </>
            }
            {
              showWordList && !detail?.showWordListOnly && <Divider style={{ paddingRight: 20,color:'#4a70ff' }}>全文字段</Divider>
            }
            {
              showWordList && params.WordList?.map((i, index) => {
                const selectRectVal = getSelectRectKey({
                  data: i,
                  key: 'Coord',
                  valStr: i.DetectedText
                });
                return <Form.Item
                  className={`${selectRectVal && selectRect == selectRectVal ? 'isSelect' : ''} list`}
                  key={index}
                  label=""
                  onClick={() => {
                    onSelect && onSelect(i.DetectedText, selectRectVal);
                  }}
                >
                  {i.DetectedText}
                </Form.Item>

              }
              )
            }
          </>

          break;
        case "invoice": // 票据识别
          paramsCon = <>
            {
              params[config.firstField]?.map((v, index) => {
                let OtherTexts = v.SingleInvoiceInfos[v.SubType];
                let invoiceDetailConfig = invoiceConfig[v.SubType] || invoiceConfig.default;
                const selectRectVal = getSelectRectKey({
                  data: v,
                  key: detail?.rectConfig?.RectKey,
                  valStr: v.SubType
                });
                return <div
                  onClick={() => {
                    onSelect && onSelect(v.SubType, selectRectVal);
                  }}
                  className={`${selectRect && selectRect == selectRectVal ? 'isSelect' : ''} invoiceContent`}
                >
                  <Form.Item
                    active
                    label={`票据类型`}
                    className="unv-form__item-group"
                  >
                    {config.invoiceTypeMap[v.Type]}
                  </Form.Item>
                  <Form.Item
                    active
                    label={`旋转角度`}
                    className="unv-form__item-group"
                  >
                    {v.Angle}
                  </Form.Item>
                  <Form.Item
                    active
                    label={`位置信息`}
                    className="unv-form__item-group"
                  >
                    {JSON.stringify(v.Polygon)}
                  </Form.Item>
                  {
                    OtherTexts &&
                    <>
                      {
                        Object.keys(OtherTexts)?.map((k, index) => {
                          if (OtherTexts[k] !== '' && !(OtherTexts[k] instanceof Object)) {
                            return childMapCom({
                              key: k,
                              value: OtherTexts[k],
                              dep: 0,
                              config: invoiceDetailConfig
                            })
                          } else if ((OtherTexts[k] instanceof Object)) {
                            if (isObjectEmptyValues(OtherTexts[k])) return <></>
                            else {
                              return <>
                                <Form.Item
                                  active
                                  label={`${invoiceDetailConfig[k]?._Label || '其他字段'}`}
                                  className="unv-form__item-group"
                                >
                                  {
                                    OtherTexts[k]?.map((o, i) => {//TODO: 0 以下还有数组，均以name显示
                                      if (o.OtherInvoiceItemList) {
                                        return <>
                                          {
                                            o.OtherInvoiceItemList?.map(other => {
                                              return <p key={i} className="mb-10"><span><b>{other.Name}: </b></span><span>{other.Value}</span></p>
                                            })
                                          }
                                        </>
                                      } else {
                                        if (o.Name && o.Value) {
                                          return <p key={i} className="mb-10"><span><b>{o.Name}: </b></span><span>{o.Value}</span></p>
                                        } else {
                                          if (!isObjectEmptyValues(o)) {
                                            return <>
                                              {
                                                Object.keys(o)?.map((ckey, index) => {
                                                  if (o[ckey] || o[ckey] === 0) {
                                                    return <p className="mb-10">
                                                      <span><b>{invoiceDetailConfig[k][ckey]?._Label || invoiceDetailConfig[k][ckey] || ckey}: </b></span>
                                                      <span>{o[ckey]}</span>
                                                    </p>
                                                  }

                                                })
                                              }
                                            </>
                                          }
                                        }
                                      }
                                    })
                                  }
                                </Form.Item>
                              </>
                            }

                          }
                        })
                      }
                    </>
                  }
                </div>
              })
            }
          </>
          break;
        case 'store':
          paramsCon = <>
            <Form.Item label="图片类型">
              {params.StoreLabel?.includes('标准门头照') ? '标准门头照' : '非标准门头照'}
            </Form.Item>
            {
              params.StoreInfo?.map((i, index) => {
                const selectRectVal = getSelectRectKey({
                  data: i,
                  key: detail?.rectConfig?.RectKey,
                  valStr: i.Value
                });
                return (
                  <Form.Item
                    className={`${selectRectVal && selectRect == selectRectVal ? 'isSelect' : ''}`}
                    key={index}
                    label={i.Name}
                    onClick={() => {
                      onSelect && onSelect(i.Value, selectRectVal);
                    }}
                  >
                    {i.Value}
                  </Form.Item>
                )
              })
            }
          </>
          break;
        case 'edu':
          paramsCon = <>
            {
              !isLoading &&
              <EduCom selectRect={selectRect} questionInfo={params.QuestionInfo} onSelect={(i) => onSelect && onSelect(i, i)} />
            }
          </>
          break;
        case 'markEdu':
          const markInfosData = eduMarkData?.data?.Response?.MarkInfos || eduMarkData?.MarkInfos || params.MarkInfos || [];
          const questionInfoData = eduMarkData?.data?.Response?.QuestionInfo?.[0]?.ResultList || eduMarkData?.QuestionInfo?.[0]?.ResultList || [];
          paramsCon = <>
            {
              !isLoading &&
              <EduMarkCom 
                selectRect={selectRect} 
                questionInfo={questionInfoData} 
                markInfos={markInfosData} 
                isMarkLoading={isMarkLoading}
                rects={rects}
                onSelect={(i) => onSelect && onSelect(i, i)} 
              />
            }
          </>
          break;
        case 'essayEdu':
          const essayData = params?.SentenceSuggests || [];
          paramsCon = <>
            {
              !isLoading &&
              <EssayEduCom 
                selectRect={selectRect} 
                essayData={essayData} 
                onSelect={(i) => onSelect && onSelect(i, i)} 
              />
            }
          </>
          break;
      }

      return paramsCon
    } catch (e) {
      return <></>
    }

  }

  const handleDealParams = (params, resultType) => {
    let _params = params;
    if (JSON.stringify(_params) === '{}') return <>{emptyCom()}</>;
    let paramsCon = <>{emptyCom()}</>;
    if (params.error) {
      paramsCon = <div className="result_error_content">
        <span className="ocrDemo-icon-error"></span>
        <span className="result_error_content_text"> {_params.message}</span>
      </div>;
      return paramsCon
    } else {
      if (Array.isArray(resultConfig)) {
        return <>
          {
            resultConfig.map(item => (
              dealParams(params, item, resultType === 'OpenResult' ? 'OpenResult' : item.type)
            ))
          }
        </>
      } else {
        let type = resultType === 'OpenResult' ? 'OpenResult' : resultConfig.type
        return <>{dealParams(params, resultConfig, type)}</>
      }
    }

  }
  return (
    <Form layout="horizontal" split>
      {
        resultType === 'OpenResult' ? <>
          {
            handleDealParams(params, resultType)
          }
        </> :
          <>
            {isLoading ? (waitingType === 'OpenResult' ? deepseekingCom() : resultingCom(detail?.loadingText)) : handleDealParams(params, resultType)}
          </>
      }
    </Form>
  );
}

export default OutputParams;
